/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Chat_Note_TrainerInputs */

const en_us2_coaching_chat_note_trainer = /** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you, the group's trainers and the student read this conversation. Their conversations with the AI stay theirs alone.`)
};

const pt_br2_coaching_chat_note_trainer = /** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só você, os personais da turma e o aluno leem esta conversa. As conversas dele com a IA continuam só dele.`)
};

const pt_pt2_coaching_chat_note_trainer = /** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só você, os personais da turma e o aluno leem esta conversa. As conversas dele com a IA continuam só dele.`)
};

/** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */
const es_419_coaching_chat_note_trainer = en_us2_coaching_chat_note_trainer;

/** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */
const fr_fr2_coaching_chat_note_trainer = en_us2_coaching_chat_note_trainer;

/** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */
const de_de2_coaching_chat_note_trainer = en_us2_coaching_chat_note_trainer;

/** @type {(inputs: Coaching_Chat_Note_TrainerInputs) => LocalizedString} */
const it_it2_coaching_chat_note_trainer = en_us2_coaching_chat_note_trainer;

/**
* | output |
* | --- |
* | "Only you, the group's trainers and the student read this conversation. Their conversations with the AI stay theirs alone." |
*
* @param {Coaching_Chat_Note_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_chat_note_trainer = /** @type {((inputs?: Coaching_Chat_Note_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Chat_Note_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_chat_note_trainer(inputs)
	if (locale === "es-419") return es_419_coaching_chat_note_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_chat_note_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_chat_note_trainer(inputs)
	if (locale === "de-DE") return de_de2_coaching_chat_note_trainer(inputs)
	if (locale === "it-IT") return it_it2_coaching_chat_note_trainer(inputs)
	return en_us2_coaching_chat_note_trainer(inputs)
});
export { coaching_chat_note_trainer as "coaching.chat_note_trainer" }